import React from "react";
import img from "./banner.png";
const Shape = () => {
	return (
		<img src={img} alt="" />
		// <svg width={696} height={795} viewBox="0 0 696 795" fill="none">
		// 	<g filter="url(#filter0_f_21_9)">
		// 		<path
		// 			d="M117.239 477.91C217.476 522.46 334.668 476.907 378.995 376.166C423.322 275.424 378 157.641 277.761 113.09C177.525 68.5397 60.332 114.092 16.0047 214.834C-28.3228 315.576 17.0013 433.359 117.239 477.91Z"
		// 			fill="url(#paint0_radial_21_9)"
		// 		/>
		// 	</g>
		// 	<defs>
		// 		<filter
		// 			id="filter0_f_21_9"
		// 			x={-301}
		// 			y={-204}
		// 			width={997}
		// 			height={999}
		// 			filterUnits="userSpaceOnUse"
		// 			colorInterpolationFilters="sRGB"
		// 		>
		// 			<feFlood floodOpacity={0} result="BackgroundImageFix" />
		// 			<feBlend
		// 				mode="normal"
		// 				in="SourceGraphic"
		// 				in2="BackgroundImageFix"
		// 				result="shape"
		// 			/>
		// 			<feGaussianBlur
		// 				stdDeviation={150}
		// 				result="effect1_foregroundBlur_21_9"
		// 			/>
		// 		</filter>
		// 		<radialGradient
		// 			id="paint0_radial_21_9"
		// 			cx={0}
		// 			cy={0}
		// 			r={1}
		// 			gradientUnits="userSpaceOnUse"
		// 			gradientTransform="translate(582.56 539.661) rotate(-154.327) scale(917.99 836.225)"
		// 		>
		// 			<stop offset="0.34394" stopColor="#00EBFF" />
		// 			<stop offset="0.619147" stopColor="#FF39B0" />
		// 			<stop offset="0.974236" stopColor="#161C1B" />
		// 		</radialGradient>
		// 	</defs>
		// </svg>
	);
};

export default Shape;
